module.exports = __webpack_public_path__ + "img/switch.0778004c.svg";